import { nanoid } from 'nanoid'
import { ReactNode } from 'react'

import { emitter, MessageAddEvent, MessageRemoveEvent } from './events'
import { MessageType } from './type'

type ShowMessageOptionType = Omit<MessageType, 'id' | 'type' | 'content'>

export { MessageContainer } from './MessageContainer'

export const message = {
  open({ type, content, action, duration = 1500 }: Omit<MessageType, 'id'>) {
    const id = nanoid()

    emitter.emit(MessageAddEvent, { id, type, content, action })

    if (duration !== 0) {
      setTimeout(() => {
        emitter.emit(MessageRemoveEvent, id)
      }, duration)
    }

    return id
  },
  close(id: string) {
    emitter.emit(MessageRemoveEvent, id)
  },
  show(content: string | ReactNode, option?: ShowMessageOptionType) {
    return this.open({ type: 'default', content, ...option })
  },
  success(content: string | ReactNode, option?: ShowMessageOptionType) {
    return this.open({ type: 'success', content, ...option })
  },
  error(content: string | ReactNode, option?: ShowMessageOptionType) {
    return this.open({ type: 'error', content, ...option })
  },
}
